import { render } from "./StatusSelector.vue?vue&type=template&id=510066c9"
import script from "./StatusSelector.vue?vue&type=script&lang=js"
export * from "./StatusSelector.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__